import PropTypes from 'prop-types';
import React from 'react';

import { mediumUp } from 'constants/mediaQueries';

const MIN_HEIGHT = 250;

const DrawerBody = ({ children }) => (
  <div className="Drawer__body" id="drawer-body">
    {children}

    <style jsx>
      {`
        .Drawer__body {
          position: relative;
        }

        @media ${mediumUp} {
          .Drawer__body {
            overflow: auto;
            height: 100%;
            min-height: ${MIN_HEIGHT}px;
          }
        }
      `}
    </style>
  </div>
);

DrawerBody.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default DrawerBody;
